import { useState, useEffect, useCallback } from 'react';
import apiService from '../services/api';

export interface SubscriptionStatus {
  plan: 'free' | 'pro' | 'clinic' | 'super_admin';
  status: 'active' | 'trialing' | 'past_due' | 'cancelled' | 'paused' | null;
  isProActive: boolean;
  isClinicActive: boolean;
  currentPeriodEnd: string | null;
  paddleSubscriptionId: string | null;
}

const defaultStatus: SubscriptionStatus = {
  plan: 'free',
  status: null,
  isProActive: false,
  isClinicActive: false,
  currentPeriodEnd: null,
  paddleSubscriptionId: null,
};

export function useSubscription(authenticated: boolean) {
  const [subscription, setSubscription] = useState<SubscriptionStatus>(defaultStatus);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!authenticated) {
      setSubscription(defaultStatus);
      setLoading(false);
      return;
    }
    try {
      const res = await apiService.get('/api/billing/status');
      if (res.success && res.data) {
        setSubscription(res.data as SubscriptionStatus);
      }
    } catch {
      // silently fall back to free
    } finally {
      setLoading(false);
    }
  }, [authenticated]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { subscription, loading, refresh };
}
